module.exports = __webpack_public_path__ + "img/22966500000115.c51c73f2.png";